module.exports = __webpack_public_path__ + "static/media/scanner-image.0b44934d.svg";